import { render, staticRenderFns } from "./EquiposActions.vue?vue&type=template&id=5afb8692&"
import script from "./EquiposActions.vue?vue&type=script&lang=ts&"
export * from "./EquiposActions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5afb8692', component.options)
    } else {
      api.reload('5afb8692', component.options)
    }
    module.hot.accept("./EquiposActions.vue?vue&type=template&id=5afb8692&", function () {
      api.rerender('5afb8692', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/Equipos/EquiposActions.vue"
export default component.exports